import { Controller } from "@hotwired/stimulus"

const DONE_ICON =
  "mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-positive/15 text-[0.625rem] font-bold text-positive"
const PENDING_ICON =
  "mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border border-border bg-bg text-[0.625rem] font-bold text-muted"

export default class extends Controller {
  static targets = ["step", "doneCount"]
  static values = { savedPhotos: { type: Number, default: 0 } }

  connect() {
    this.refresh()
  }

  refresh() {
    const savedPhotos = document.querySelectorAll("#listing-photo-grid [data-photo-card]").length
    const pendingPhotos = this.element.querySelector("[data-listing-photos-target='pending']")?.children.length || 0
    const rent = this.listingKind() === "rent"
    const checks = {
      photos: this.savedPhotosValue > 0 || savedPhotos > 0 || pendingPhotos > 0,
      title: this.hasText("pro_listing[title]"),
      description: this.hasText("pro_listing[description]"),
      price: rent
        ? this.positiveNumber("pro_listing[monthly_rent_pln]")
        : this.positiveNumber("pro_listing[asking_price_pln]"),
      area: this.positiveNumber("property[area_m2]"),
    }

    let done = 0
    this.stepTargets.forEach((step) => {
      const complete = checks[step.dataset.stepKey]
      if (complete) done += 1
      this.renderStep(step, complete)
    })

    if (this.hasDoneCountTarget) {
      this.doneCountTarget.textContent = String(done)
    }
  }

  listingKind() {
    return this.element.querySelector('[name="pro_listing[listing_kind]"]')?.value || "sale"
  }

  hasText(name) {
    const value = this.element.querySelector(`[name="${name}"]`)?.value
    return value?.trim().length > 0
  }

  positiveNumber(name) {
    const raw = this.element.querySelector(`[name="${name}"]`)?.value
    const n = parseFloat(raw)
    return Number.isFinite(n) && n > 0
  }

  renderStep(step, done) {
    const icon = step.querySelector("[data-check-icon]")
    if (icon) {
      icon.textContent = done ? "✓" : ""
      icon.className = done ? DONE_ICON : PENDING_ICON
    }
    step.classList.toggle("font-medium", !done)
    step.classList.toggle("text-ink", !done)
    step.classList.toggle("text-muted", done)
  }
}
